// components/ProtectedRoute.js
import { Navigate } from 'react-router-dom';
import { useUser } from './UserContext';

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { currentUser, userData, loading } = useUser();

  if (loading) {
    return <div>Loading...</div>; // Or your loading component
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && (!userData || !userData.isAdmin)) {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
};

export const AuthRoute = ({ children }) => {
  const { currentUser, loading } = useUser();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (currentUser) {
    return <Navigate to="/" replace />;
  }

  return children;
};